
window.addEventListener("load", function () {
	const Loader = document.querySelector(".Loader");
	Loader.classList.add("hidden");
});

AOS.init({
    once: true,
});

class Counter {
    constructor(targetElem, newValue) {
        this.targetElem = targetElem;
        this.targetObj = { val: 0 };
        this.newValue = newValue;
        this.startTween = this.startTween.bind(this);
        this.init();
    }

    init() {
        this.targetElem.innerHTML = this.targetObj.val;
    }

    startTween() {
        TweenLite.to(this.targetObj, 5, {
            val: this.newValue,
            roundProps: "val",
            onUpdate: () => {
                this.targetElem.innerHTML = this.targetObj.val;
            }
        });
    }
}

function handleIntersect(entries, observer) {
    entries.forEach((entry) => {
        if (entry.isIntersecting) {
            observer.unobserve(entry.target);
            const newValue = parseInt(entry.target.dataset.newValue, 10);
            new Counter(entry.target, newValue).startTween();
        }
    });
}

const counterElements = document.querySelectorAll(".counter");
const observerOptions = {
    root: null,
    rootMargin: "0px",
    threshold: 0.1,
};

const observer = new IntersectionObserver(handleIntersect, observerOptions);
counterElements.forEach((counterElement) => observer.observe(counterElement));


var swiper = new Swiper(".mySwiper", {
    slidesPerView: 3,
    spaceBetween: 24,
    pagination: {
        el: ".swiper-pagination",
        clickable: true,
    },
    breakpoints: {
        0: {
            slidesPerView: 1
        },
        768: {
            slidesPerView: 2,
        },
        1024: {
            slidesPerView: 3,
        },
    }
});

var swiper = new Swiper('.heroSwiper', {
    spaceBetween: 30,
    centeredSlides: true,
    effect: "fade",
    autoplay: {
        delay: 3000,
        disableOnInteraction: false,
    },
});
$('[data-countdown]').each(function() {
    var $this = $(this), finalDate = $(this).data('countdown');
    $this.countdown(finalDate, function(event) {
      $this.html(event.strftime('%H : %M : %S'));
    });
});

$('#clock').countdown('2030/10/10', function(event) {
    $('#days').html(event.strftime('%D'));
    $('#hours').html(event.strftime('%H'));
    $('#minutes').html(event.strftime('%M'));
    $('#seconds').html(event.strftime('%S'));
});
